import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class PtbrExternalLoadsEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      id: '',
      type: '',
      description: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.locale = getLocale();

    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_ptbr_external_load.id !== 'undefined') {
        this.setState({
          type: newProps.data_ptbr_external_load.type,
          description: newProps.data_ptbr_external_load.description,
          id: newProps.data_ptbr_external_load.id,
        });
      }
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      type: this.state.type,
      description: this.state.description,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/carga-externa', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tituloEditarCargaExternaPTBR}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.edit}> 
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formularioEditarCargaExternaPTBR.Tipo}:</label>
                    <input type="text" name="type" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formularioEditarCargaExternaPTBR.placeholder.Tipo} value={this.state.type} onChange={this.handleChange.bind(this, 'type')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formularioEditarCargaExternaPTBR.Descricao}:</label>
                    <input type="text" name="description" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formularioEditarCargaExternaPTBR.placeholder.Descricao} value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.formularioEditarCargaExternaPTBR.botaoEditarCargaExternaPTBR}</button>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PtbrExternalLoadsEditModal;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/PtbrExternalLoadsEditModal.js